// Config module — replaces server/config-loader.ts
// In static mode, we use hardcoded example repos + user-configured repos from IndexedDB

import type { PredefinedRepo } from "./types";
import { getUserRepos } from "./storage";

// Example public repos (same as server/config-loader.ts)
export const EXAMPLE_REPOS: PredefinedRepo[] = [
  {
    id: "example-react",
    name: "React",
    description: "A JavaScript library for building user interfaces",
    type: "github",
    url: "https://github.com/facebook/react",
    icon: "⚛️",
    color: "#61dafb",
  },
  {
    id: "example-vue",
    name: "Vue.js",
    description: "Progressive JavaScript Framework",
    type: "github",
    url: "https://github.com/vuejs/core",
    icon: "💚",
    color: "#42b883",
  },
  {
    id: "example-svelte",
    name: "Svelte",
    description: "Cybernetically enhanced web apps",
    type: "github",
    url: "https://github.com/sveltejs/svelte",
    icon: "🔥",
    color: "#ff3e00",
  },
  {
    id: "example-bun",
    name: "Bun",
    description: "Incredibly fast JavaScript runtime",
    type: "github",
    url: "https://github.com/oven-sh/bun",
    icon: "🥟",
    color: "#fbf0df",
  },
  {
    id: "example-elysia",
    name: "Elysia",
    description: "Ergonomic Framework for Humans",
    type: "github",
    url: "https://github.com/elysiajs/elysia",
    icon: "🦊",
    color: "#a855f7",
  },
];

// Get all repos (examples + user-configured from IndexedDB)
export async function getAllRepos(): Promise<PredefinedRepo[]> {
  const repos: PredefinedRepo[] = [...EXAMPLE_REPOS];

  try {
    const userRepos = await getUserRepos();
    for (const repo of userRepos) {
      repos.push({
        id: repo.id,
        name: repo.name,
        type: repo.type as PredefinedRepo["type"],
        url: repo.url,
      });
    }
  } catch {
    // IndexedDB not available or empty
  }

  return repos;
}
